import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { DisciplineFilterOptionInformation } from '@studyportals/search-filters';
import DisciplineFilterOptionInformationFactory from '../filter/discipline/DisciplineFilterOptionInformationFactory';

class DisciplineFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DISCIPLINES,
			DisciplineFilterOptionInformationFactory.getDisciplineFilterInformation(),
			DisciplineFilterOptionInformationFactory.getDisciplineFilterOptionValues()
		);
	}

	public getDisciplineInformation(disciplineValue: string): DisciplineFilterOptionInformation | undefined {
		return this.filterInformation.find((_) => _.optionValue === disciplineValue) as DisciplineFilterOptionInformation;
	}

	public getPathRegex(): string {
		return super.getPathRegex().concat('|', this.getSynonyms().join('|'));
	}

	public getSynonyms(): string[] {
		return (this.filterInformation as DisciplineFilterOptionInformation[])
			.filter((_) => _.synonym !== undefined && _.synonym !== '')
			.map((_) => _.synonym);
	}
}

export default new DisciplineFilterDefinition();
